// @flow
import React from 'react';
import Accordion from 'cms-accordion.svg';
import Anchor from 'cms-anchor.svg';
import Blockquote from 'cms-blockquote.svg';
import CtaHero from 'cms-cta-hero.svg';
import CtaPromo from 'cms-cta-promo.svg';
import EmailCampaignSignupDouble from 'cms-email-campaign-signup-double.svg';
import EmailCampaignSignupSingle from 'cms-email-campaign-signup-single.svg';
import FourArticlesHighlight from 'cms-four-articles-highlight.svg';
import FreeCode from 'cms-free-code.svg';
import GradCtaHero from 'cms-grad-cta-hero.svg';
import Image from 'cms-image.svg';
import Richtext from 'cms-richtext.svg';
import StickyHeaderLinks from 'cms-sticky-header-links.svg';
import StickyHeaderLinksGrad from 'cms-sticky-header-links-grad.svg';
import ThreeSectionSlider from 'cms-three-section-slider.svg';
import ThreeStepCta from 'cms-three-step-cta.svg';
import TwoTiles from 'cms-two-tiles.svg';
import Video from 'cms-video.svg';
import RandomGradPrograms from 'cms-random-grad-programs.svg';
import CategoryHighlight from 'cms-category-highlight.svg';
import IdealistDaysMap from 'cms-idealist-days-map.svg';
import SplitContent from 'cms-split-content.svg';
import ImageGallery from 'cms-image-gallery.svg';
import FlashCardQuiz from 'cms-flash-card-quiz.svg';
import PersonaQuiz from 'cms-persona-quiz.svg';
import SupportContactForm from 'cms-support-contact-form.svg';
import TileGrid from 'cms-tile-grid.svg';
import Donate from 'cms-donate.svg';
import GradFairGradProgramLinks from 'cms-grad-fair-grad-program-links.svg';
import FormBuilder from 'clipboard.svg';
import Icon from 'components/Icon';

const getIconComponent = name => {
  switch (name) {
    case 'accordion':
      return Accordion;
    case 'anchor':
      return Anchor;
    case 'blockquote':
      return Blockquote;
    case 'cta-hero':
      return CtaHero;
    case 'cta-promo':
      return CtaPromo;
    case 'email-campaign-signup-double':
      return EmailCampaignSignupDouble;
    case 'email-campaign-signup-single':
      return EmailCampaignSignupSingle;
    case 'four-articles-highlight':
      return FourArticlesHighlight;
    case 'free-code':
      return FreeCode;
    case 'grad-cta-hero':
      return GradCtaHero;
    case 'image':
      return Image;
    case 'richtext':
      return Richtext;
    case 'sticky-header-links':
      return StickyHeaderLinks;
    case 'sticky-header-links-grad':
      return StickyHeaderLinksGrad;
    case 'three-section-slider':
      return ThreeSectionSlider;
    case 'three-step-cta':
      return ThreeStepCta;
    case 'two-tiles':
      return TwoTiles;
    case 'video':
      return Video;
    case 'random-grad-programs':
      return RandomGradPrograms;
    case 'category-highlight':
      return CategoryHighlight;
    case 'idealist-days-map':
      return IdealistDaysMap;
    case 'split-content':
      return SplitContent;
    case 'image-gallery':
      return ImageGallery;
    case 'flash-card-quiz':
      return FlashCardQuiz;
    case 'persona-quiz':
      return PersonaQuiz;
    case 'support-contact-form':
      return SupportContactForm;
    case 'tile-grid':
      return TileGrid;
    case 'donate':
      return Donate;
    case 'grad-fair-grad-program-links':
      return GradFairGradProgramLinks;
    case 'form-builder':
      return FormBuilder;
    default:
      return Image;
  }
};

const CmsIcon = ({ name, ...props }: { name: string }) => (
  <Icon component={getIconComponent(name)} {...props} />
);

export default CmsIcon;
